import React, { PureComponent } from 'react'
import { number, string, oneOfType } from 'prop-types'
import { minutes } from 'utils/string'
import { TableCell } from './TableCell'

export class MinutesTableCell extends PureComponent {
    static propTypes = {
        children: oneOfType([number, string])
    }

    render() {
        const { children, ...otherProps } = this.props
        return <TableCell {...otherProps}>{minutes(children)}</TableCell>
    }
}



// WEBPACK FOOTER //
// src/components/Table/MinutesTableCell.js